import React, { useState, useEffect } from 'react';
import './Footer.css';
import facebookIcon from '../assets/icons8-facebook-50.png';
import instagramIcon from '../assets/icons8-instagram-logo-50.png';
import linkedinIcon from '../assets/icons8-linkedin-50.png';
import phoneIcon from '../assets/icons8-phone-50.png';
import locationIcon from '../assets/icons8-location-50.png';
import emailIcon from '../assets/icons8-mail-50.png';
import { generateWhatsAppUrl } from '../utils/whatsapp';

function Footer() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <footer className="footer">
                <div className="footer-container">
                    <div className="footer-section">
                        <h3>Contact</h3>
                        <p className="contact-inline">
                            <img src={phoneIcon} alt="WhatsApp" className="contact-icon" />
                            <a
                                href={generateWhatsAppUrl('+40 752 875 121')}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: 'white',
                                    textDecoration: 'none',
                                    cursor: 'pointer'
                                }}
                                title="Contactează-ne pe WhatsApp"
                            >
                                <i className="fab fa-whatsapp" style={{ marginRight: '8px' }}></i>
                                +40 752 875 121
                            </a>
                        </p>
                        <p className="contact-inline">
                            <img src={emailIcon} alt="Email" className="contact-icon" />
                            <a href="mailto:contact@evoomedical.ro">contact@evoomedical.ro</a>
                        </p>
                        <p className="contact-inline">
                            <img src={locationIcon} alt="Location" className="contact-icon" />
                            <a href="https://maps.app.goo.gl/qdBZb33UPuqRvRyf8" target="_blank" rel="noopener noreferrer">Strada 1 Mai, Nr 294, Petrești-Sebeș</a>
                        </p>
                        <div className="social-links">
                            <a href="https://facebook.com/evoomedical" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <img src={facebookIcon} alt="Facebook" className="social-icon" />
                            </a>
                            <a href="https://instagram.com/evoomedical" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <img src={instagramIcon} alt="Instagram" className="social-icon" />
                            </a>
                            <a href="https://linkedin.com/company/evoomedical" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
                            </a>
                        </div>
                    </div>
                    <div className="footer-section">
                        <h3>Informații</h3>
                        <ul>
                            <li><a href="/termeni-si-conditii">Termeni și Condiții</a></li>
                            <li><a href="/politica-de-confidentialitate">Politica de Confidențialitate</a></li>
                            <li><a href="/politica-de-cookies">Politica de Cookies</a></li>
                            <li><a href="/gdpr">Informații GDPR</a></li>
                            <li><a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer">Protecția Consumatorilor - ANPC</a></li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3>Locație</h3>
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2774.7682828996058!2d23.56194932379877!3d45.93593085596629!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDXCsDU2JzA3LjkiTiAyM8KwMzMnNDIuMiJF!5e0!3m2!1sen!2sro!4v1756840785463!5m2!1sen!2sro"
                                width="100%"
                                height="200"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="eager"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Evoo Medical Location"
                            ></iframe>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2026 Evoo Medical. Toate drepturile rezervate.</p>
                </div>
            </footer>
            {isVisible && (
                <button
                    className="back-to-top-fixed visible"
                    onClick={scrollToTop}
                    aria-label="Scroll to top"
                >
                    ↑
                </button>
            )}
        </>
    );
}

export default Footer;
